<template>
  <!-- insights cards -->
  <div class="grid md:grid-cols-4 gap-4" v-if="campaign !== null">
    <speakol-analytics-card
      :title="analytics.impressions | addComma"
      subTitle="Impressions"
      icon="speakol-eye"
      backgroundColor="#DFF2FA"
      color="#0092D7"
      class="sub-card mb-4 lg:mr-14 lg:sub-card md:mr-2"
      tooltip="This indicates the number of times users have seen your ads. Every time your ads are displayed, it counts as one impression.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="analytics.clicks | addComma"
      subTitle="Clicks"
      icon="speakol-finger-click"
      backgroundColor="#FFF3E8"
      color="#FF9F43"
      class="sub-card mb-4 lg:mr-14 lg:sub-card md:mr-2"
      tooltip="This indicates the total number of user clicks that your campaign ads have received.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="analytics.ctr | addComma('%')"
      subTitle="CTR"
      icon="speakol-percentage-sign"
      backgroundColor="#EEF8F7"
      color="#6EC8BA"
      class="sub-card mb-4 lg:mr-14 lg:sub-card md:mr-2"
      tooltip="Clicks through Rate determines the percentage of user clicks that your campaign ads have received. You can calculate your CTR by dividing the number of user clicks by the number of impressions.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="analytics.average_cpc | addComma('$')"
      subTitle="Avg. CPC"
      icon="speakol-us-dollar"
      backgroundColor="#F5ECE5"
      color="#AB6226"
      class="sub-card mb-4  lg:sub-card"
      tooltip="This indicates the average amount of money charged per campaign ad click. You can calculate your Avg. CPC by dividing the total cost of clicks by the total number of clicks.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="analytics.video_views | addComma"
      subTitle="Video Views"
      icon="speakol-start"
      backgroundColor="#FBE5E5"
      color="#DB2828"
      class="sub-card mb-4  lg:sub-card md:mr-2"
      tooltip="This indicates the number of videos a user watches after he/she clicks on your campaign ad.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="analytics.spent | addComma('$')"
      subTitle="Spent"
      icon="speakol-us-dollar"
      backgroundColor="#FDF9EE"
      color="#F0C970"
      class="sub-card mb-4  lg:sub-card"
      tooltip="This indicates the total budget spent on ad campaigns over a selected period.">
    </speakol-analytics-card>

    <speakol-analytics-card
      :title="(analytics[pixelEvent] || 0) | addComma"
      :subTitle="$t(pixelEvent)"
      icon="speakol-user-account"
      backgroundColor="#F5FAEE"
      color="#AAD575"
      class="sub-card mb-4  lg:sub-card md:mr-2"
      tooltip="This indicates the total number of users who took action on your landing pages.">

      <template v-slot:action v-if="campaign.lead_form_id && pixelEvent === 'leads'">
        <a href="#" @click.prevent="performAction()">{{$t('Download')}}</a>
      </template>
    </speakol-analytics-card>


    <speakol-analytics-card
      :title="(analytics[pixelEvent] > 0 ? analytics.spent / analytics[pixelEvent] : 0) | addComma('$')"
      subTitle="CPA"
      icon="speakol-us-dollar"
      backgroundColor="#F3EAFB"
      color="#9B51E0"
      class="sub-card mb-4 lg:sub-card"
      tooltip="This indicates the amount of money charged when users become customers by completing an action on your landing page.">
    </speakol-analytics-card>

    <SpeakolExport
      :fileName="leadFromExportedFileName"
      :isActive="isExportPopupActive"
      exportType="campaign-lead-forms"
      :params="{...filters, ...exportSortModel, ...{campaignId: campaign.id}}"
      @hide="isExportPopupActive=false"
    />

  </div>
  <!-- insights cards -->
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import SpeakolExport from  '@/components/SpeakolExport'
import leadFormExportFileName from '@/helpers/leadFormExportFileName.js'

export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  components: {
    'analytics-card-line': StatisticsCardLine,
    SpeakolExport
  },
  data () {
    return {
      campaign: null,
      filterAdset: null,
      isExportPopupActive: false,
      exportSortModel: {
        sortBy: 'id',
        isASC: false
      }
    }
  },
  computed: {
    leadFromExportedFileName () {
      return leadFormExportFileName(this.campaign.name)
    },

    showDownloadBtn () {
      return this.campaign.lead_form_id && this.pixelEvent === this.$constants.ANALYTICS_EVENTS_NAMES.LEADS
    },

    analytics () {
      if (this.filterAdset) {
        const adset = this.campaign.adsets.find(i => i.id === this.filterAdset)
        if (adset) {
          return adset.analytics
        }
      }

      return this.campaign.analytics
    },
    pixelEvent () {
      return (!this.filters.pixelEvent || this.filters.pixelEvent === 'total') ? 'conversions' : this.filters.pixelEvent
    }
  },
  async created () {
    await this.fetchInsights()
  },
  methods: {
    performAction () {
      this.isExportPopupActive = true
    },

    async fetchInsights () {
      try {


        const response = await window.axios.get(`/campaigns/${this.$route.params.id}/insights`, {
          params: {
            from_date: this.filters.dateRange.startDate,
            to_date: this.filters.dateRange.endDate
          }
        })

        this.campaign = response.data.payload

        this.filterAdset = this.filters.adset


      } catch (error) {
        alert('Error processing the request')
      }
    }
  }
}
</script>

<style lang="scss">
  .tooltip-icon {
    cursor: pointer;
  }
</style>
